import { getAcvParentOriginForPostMessage } from './acvParentOrigin';

/**
 * Notify the ACV host (ACVLayout) that a blocking fullscreen modal is open in the iframe.
 * The host sets `data-acv-iframe-modal-open` and draws a veil over the ACV navbar/chatbar.
 *
 * Use ONLY for true blocking dialogs (recording modal, confirm dialogs).
 * Do NOT call this for My Library video playback — that is in-iframe content, not a
 * host-chrome modal (contract points 7-8 in Docs/ACV-Iframe-Communication-Contract-EN.md).
 *
 * Host: ACV/src/components/Layout/ACVLayout.js (message handler).
 */
function buildPayload(
  open: boolean,
  options?: { sidebarWidth?: number }
): {
  type: string;
  open: boolean;
  sidebarWidth?: number;
  source: string;
} {
  const payload: {
    type: string;
    open: boolean;
    sidebarWidth?: number;
    source: string;
  } = {
    type: 'acv-iframe-modal-open',
    open,
    source: 'aiRecording',
  };
  if (open && typeof options?.sidebarWidth === 'number' && Number.isFinite(options.sidebarWidth)) {
    payload.sidebarWidth = Math.max(0, options.sidebarWidth);
  }
  return payload;
}

/**
 * Posts to the parent. If origin cannot be resolved, falls back to '*' so ACVLayout
 * still receives the message (same trade-off as acv-leftsidebar-metrics in App.tsx).
 */
export function notifyAcvIframeModalOpen(
  open: boolean,
  options?: { sidebarWidth?: number }
): void {
  try {
    if (typeof window === 'undefined' || window.parent === window) return;

    const payload = buildPayload(open, options);
    const targetOrigin = getAcvParentOriginForPostMessage() ?? '*';

    window.parent.postMessage(payload, targetOrigin);
  } catch {
    // ignore
  }
}
